<div
    #selectContainer
    class="custom-select z-20"
    [class.disabled]="isDisabled()"
    (click)="toggleSelect()">
    @if (label()) {
        <label class="text-base">{{ label() }}</label>
    }
    <div
        #selectDiv="cdkOverlayOrigin"
        cdk-overlay-origin
        class="input-div relative px-3 h-12 flex flex-row justify-between flex-nowrap items-center rounded-lg"
        id="select-div">
        @if (isMultiSelect() && !isOpen() && selectedOptions().length) {
            <p
                class="truncated !m-0 text-base"
                id="multi-selected-options"
                (click)="onSelectedClick($event)">
                {{
                    selectedOptions().length === 1
                        ? selectedOptions()[0].label
                        : selectedOptions().length +
                          ('selectedElement' | transloco: { COUNT: selectedOptions().length })
                }}
            </p>
        } @else if (!isMultiSelect() && !isOpen() && selectedOptions().length) {
            <div
                class="truncated !m-0 text-base flex items-center gap-2"
                id="selected-option"
                (click)="onSelectedClick($event)">
                @if (templateRef()) {
                    <ng-container
                        [ngTemplateOutlet]="templateRef()!"
                        [ngTemplateOutletContext]="{ $implicit: option() }" />
                }
                <span class="truncated">{{ option().label }}</span>
            </div>
        } @else {
            <div
                class="truncated !m-0 text-base flex items-center gap-2 w-full"
                id="selected-option">
                @if (templateRef()) {
                    <ng-container
                        [ngTemplateOutlet]="templateRef()!"
                        [ngTemplateOutletContext]="{ $implicit: option() }" />
                }
                <input
                    #selectInput
                    autocomplete="off"
                    class="rounded-lg bg-transparent w-full h-full border-none focus:outline-none text-base"
                    id="select-input"
                    type="text"
                    [autofocus]="true"
                    [class.cursor-pointer]="!isOpen()"
                    [placeholder]="placeholder() | transloco"
                    [(ngModel)]="searchValue"
                    (click)="onInputClick($event)"
                    (keyup)="keyUp($event)" />
            </div>
        }
        <div class="flex flex-row items-center">
            @if (selectedOptions().length && !isOpen() && canClear()) {
                <fa-icon
                    class="text-outline"
                    size="lg"
                    [fixedWidth]="true"
                    [icon]="['fas', 'xmark']"
                    (click)="resetSelection($event)" />
            }
            <fa-icon
                class="transition duration-200 ease-in-out"
                size="sm"
                [class.expanded]="isOpen()"
                [fixedWidth]="true"
                [icon]="['fas', 'caret-down']" />
        </div>
    </div>
</div>

<ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayFlexibleDimensions]="true"
    [cdkConnectedOverlayHasBackdrop]="false"
    [cdkConnectedOverlayOpen]="isOpen()"
    [cdkConnectedOverlayOrigin]="selectDiv"
    [cdkConnectedOverlayPositions]="openUp() ? positionsUp : positionsDown"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayScrollStrategy]="scroll.reposition()"
    (overlayOutsideClick)="closeDropdown()"
    (positionChange)="onPositionChange($event)">
    <div
        class="select-options min-w-full"
        [style.min-width.px]="dropdownWidth()">
        <div>
            @if (isMultiSelect() && options().length && (!disableSelectAll() || selectedOptions().length > 1)) {
                <div
                    class="px-2 py-1 flex flex-row items-center"
                    (click)="disableSelectAll() ? resetSelectedOptions($event) : selectAll($event)">
                    @if (!disableSelectAll()) {
                        <app-checkbox
                            class="pr-1"
                            [checkboxState]="selectAllCheckboxState()" />
                        <p class="!m-0 text-outline text-base">{{ toggleAllSelectKey() | transloco }}</p>
                    } @else if (selectedOptions().length > 1) {
                        <p
                            class="option !m-0 text-outline text-base cursor-pointer transition duration-100 ease-in-out">
                            {{ 'unselectAll' | transloco }}
                        </p>
                    }
                </div>
            }

            @if (!Object.keys(filteredOptionsByGroup()).length) {
                <div class="px-2 py-1">
                    <p class="!m-0 text-outline text-base">{{ emptyOptionLabel() | transloco }}</p>
                </div>
            }

            <div
                class="overflow-y-auto"
                [ngStyle]="{ 'max-height.px': dropdownMaxHeight }">
                @if (filteredOptionsByGroup()) {
                    @for (groupName of Object.keys(filteredOptionsByGroup()); track groupName) {
                        <div class="px-2 pt-2 pl-3 text-custom-dark-grey">
                            @if (groupName === NO_GROUP) {
                                {{ labelNoGroup() | transloco }}
                            } @else {
                                {{ groupName }}
                            }
                        </div>
                        @for (option of filteredOptionsByGroup()[groupName]; track option.label; let index = $index) {
                            <div
                                [matTooltip]="option.disabledReason || option.label"
                                [matTooltipDisabled]="!option.disabledReason && disabledTooltipList[index]"
                                [matTooltipShowDelay]="500">
                                <div
                                    #selectOptionElement
                                    class="option p-2 pl-3 cursor-pointer flex flex-row items-center transition duration-100 ease-in-out"
                                    [class.active]="option.state === CheckboxState.CHECKED"
                                    [class.disabled]="option.disabledReason"
                                    (click)="toggleOption(option, $event)">
                                    @if (optionPrefix()) {
                                        <ng-container
                                            [ngTemplateOutlet]="optionPrefix()!"
                                            [ngTemplateOutletContext]="{ $implicit: option, index: index }" />
                                    }
                                    @if (isMultiSelect()) {
                                        <app-checkbox
                                            class="pr-1"
                                            [checkboxState]="option.state" />
                                    }

                                    <p class="truncated !m-0 text-base flex-1">{{ option.label }}</p>

                                    @if (option.trailingIcon && !optionPrefix()) {
                                        <fa-icon
                                            class="h-full mx-4"
                                            [icon]="option.trailingIcon" />
                                    }
                                </div>
                            </div>
                        }
                    }
                }
            </div>
        </div>
        @if (bottomOption()) {
            <ng-container [ngTemplateOutlet]="bottomOption()!" />
        }
    </div>
</ng-template>
